const content = [
  // 首页/封面
  {
    key: "front",
    type: "frontPage",
    content: [
      {
        key: "front1",
        type: 'frontCover',
        img: require('@/assets/images/books/bookExample/front-cover.png'),
        // img: require("@/assets/images/bookContent/top_bg.png"),
      },
    ]
  },
  // 引子
  // 章标题
  {
    key: 'introduction',
    type: "title",
    category: 5, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: '引子', // *必填* 标题文本内容
    textStyle: {
      // fontFamily: 'Arial', // 字体，本地配置的字体
      // fontSize: 32, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      backgroundImage: require('@/assets/images/books/bookExample/title-center.png')// 背景图片  默认：无
    }
  },
  // 答题
  {
    key: 'introduction1', // *必填* 唯一标识
    type: 'question', // *必填* 类型：答题
    title: '小互动', // 答题的标题
    content: [
      {
        "topic_id": 30,
        "id": 30,
        "type_id": 2,
        "typenm": "多项选择题",
        "shorttag": "",
        "showway": "",
        "topic_score": "2.00",
        "isauto": 0,
        "info": "",
        "km": "",
        "stem_url": "",
        "audiofile": "",
        "audiofile_suffix": "",
        "audiofile_title": "附件下载",
        "is_collect": 0,
        "status": 0,
        "is_play": 0,
        "issign": 0,
        "isok": 0,
        "isdone": 0,
        "getscore": 0,
        "comment": "",
        "ischeck": 0,
        "ps_info": "每小题备选答案中至少有1个正确选项，请从中选择符合题意的选项作为答案。",
        "topic_sub": [
          {
            "shorttag": "",
            "direction": 0,
            "type_id": 2,
            "typenm": "多项选择题",
            "score": "2.00",
            "topic_id": 30,
            "sub_id": 1,
            "isauto": 0,
            "para44_id": 0,
            "upload_explain": "",
            "options": [],
            "showway": "",
            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">1<\/span>．你认为数字教材应该具备哪些功能？<\/span><\/p>",
            "subanalysis": "",
            "sortid": 1,
            "file_name": "",
            "user_answer": [],
            "brief_answer": {},
            "other_answer": "",
            "user_status": -1,
            "answer_img": {},
            "topic_answer": [
              {
                "topic_id": 30,
                "sub_id": 1,
                "sortid": 1,
                "ask": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">A<\/span>．多媒体集成功能<\/span><\/p>",
                "answer": "1",
                "askend": null,
                "answer_id": 1,
                "answer_url": "",
                "answertitle": null,
                "score": "1.00",
                "operation_score": 0
              },
              {
                "topic_id": 30,
                "sub_id": 1,
                "sortid": 2,
                "ask": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">B<\/span>．交互功能<\/span><\/p>",
                "answer": "0",
                "askend": null,
                "answer_id": 2,
                "answer_url": "",
                "answertitle": null,
                "score": "0.00",
                "operation_score": 0
              },
              {
                "topic_id": 30,
                "sub_id": 1,
                "sortid": 3,
                "ask": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">C<\/span>．跟踪与反馈功能<\/span><\/p>",
                "answer": "1",
                "askend": null,
                "answer_id": 3,
                "answer_url": "",
                "answertitle": null,
                "score": "1.00",
                "operation_score": 0
              },
              {
                "topic_id": 30,
                "sub_id": 1,
                "sortid": 4,
                "ask": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">D<\/span>．教学辅助功能<\/span><\/p>",
                "answer": "0",
                "askend": null,
                "answer_id": 4,
                "answer_url": "",
                "answertitle": null,
                "score": "0.00",
                "operation_score": 0
              },
              {
                "topic_id": 30,
                "sub_id": 1,
                "sortid": 4,
                "ask": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">E<\/span>．其他：例如，<\/span><\/p>",
                "answer": "0",
                "askend": null,
                "answer_id": 5,
                "answer_url": "",
                "answertitle": null,
                "score": "0.00",
                "operation_score": 0,
                "is_other": 1
              }
            ],
            "video_list": [],
            "isok": 0,
            "isdone": 0,
            "concat_answer": "AC",
            "user_concat_answer": ""
          }
        ]
      },
      {
        "topic_id": 57,
        "id": 57,
        "type_id": 4,
        "typenm": "简答题",
        "shorttag": "",
        "showway": "",
        "topic_score": "8.00",
        "isauto": 0,
        "info": "",
        "km": "",
        "stem_url": "",
        "audiofile": "",
        "audiofile_suffix": "",
        "audiofile_title": "附件下载",
        "is_collect": 0,
        "status": 0,
        "is_play": 0,
        "issign": 0,
        "isok": 0,
        "isdone": 0,
        "getscore": 0,
        "comment": "",
        "ischeck": 0,
        "ps_info": "根据相关要求，完成下列题目。",
        "topic_sub": [
            {
                "shorttag": "",
                "direction": 0,
                "type_id": 4,
                "typenm": "简答题",
                "score": "8.00",
                "topic_id": 57,
                "sub_id": 1,
                "isauto": 0,
                "is_upload": 0,
                "para44_id": 0,
                "upload_explain": "",
                "options": [],
                "showway": "",
                "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">2<\/span>．想一想，纸质教材和数字教材有什么区别呢？<\/span><\/p>",
                "subanalysis": "",
                "sortid": 1,
                "file_name": "",
                "user_answer": [],
                "brief_answer": {},
                "user_status": -1,
                "answer_img": {},
                "topic_answer": [
                  {
                    "topic_id": 57,
                    "sub_id": 1,
                    "sortid": 1,
                    "ask": "",
                    "answer": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">在长期的实践中，广大劳动者逐渐培育形成了“执着专注、精益求精、一丝不苟、追求卓越”的工匠精神。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">执着专注既是一种锲而不舍的工作态度，也是一种埋头苦干的工作习惯。崔兴国从事水电装备制造工作30多年，带领团队持续攻关、突破创新，正是执着专注的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">精益求精即要有一颗进取之心，以高标准要求自己，不断钻研工艺知识、提高技能水平。为了保证水轮机组转轮平稳运行，实现转轮静平衡试验目标，崔兴国采用了精准导向工装和扶正调整技术，使各项参数指标均优于精品标准，正是精益求精的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">一丝不苟即做事认真，不放过任何一个细节。周晶辉面对烦琐的工作，勤勤恳恳，不断试验，成功探索出了可以使焊接时各个零部件受热均匀，减少车体变形情况的焊接工艺，正是一丝不苟的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">追求卓越即不断进取、敢于开拓创新、勇于突破自我。在没有技术参考的情况下，周晶辉用时一个多月，研究出了一套可在半小时内完成精准切割的切割方法，正是追求卓越的体现。<\/span><\/p>",
                    "askend": null,
                    "answer_id": 1,
                    "answer_url": "",
                    "answertitle": null,
                    "score": "8.00",
                    "operation_score": 0
                  }
                ],
                "video_list": [],
                "isok": 0,
                "isdone": 0,
                "concat_answer": "",
                "user_concat_answer": ""
            }
        ]
      },
      {
        "topic_id": 1,
        "id": 1,
        "type_id": 1,
        "typenm": "单项选择题",
        "shorttag": "",
        "showway": "",
        "topic_score": "1.00",
        "isauto": 0,
        "info": "",
        "km": "",
        "stem_url": "",
        "audiofile": "",
        "audiofile_suffix": "",
        "audiofile_title": "附件下载",
        "is_collect": 0,
        "status": 0,
        "is_play": 0,
        "issign": 0,
        "isok": 0,
        "isdone": 0,
        "getscore": 0,
        "comment": "",
        "ischeck": 0,
        "ps_info": "每小题备选答案中，只有一个符合题意的正确答案。",
        "topic_sub": [
          {
            "shorttag": "",
            "direction": 0,
            "type_id": 1,
            "typenm": "单项选择题",
            "score": "1.00",
            "topic_id": 1,
            "sub_id": 1,
            "isauto": 0,
            "para44_id": 0,
            "upload_explain": "",
            "options": [],
            "showway": "",
            "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">3<\/span>．你知道文旌课堂吗？<\/span><\/p>",
            "subanalysis": "",
            "sortid": 1,
            "file_name": "",
            "user_answer": [],
            "brief_answer": {},
            "user_status": -1,
            "answer_img": {},
            "topic_answer": [
              {
                "topic_id": 1,
                "sub_id": 1,
                "sortid": 1,
                "ask": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">A<\/span>．知道<\/span><\/p>",
                "answer": "0",
                "askend": null,
                "answer_id": 1,
                "answer_url": "",
                "answertitle": null,
                "score": "0.00",
                "operation_score": 0
              },
              {
                "topic_id": 1,
                "sub_id": 1,
                "sortid": 2,
                "ask": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\"><span style=\"font-family:'Times New Roman'\">B<\/span>．不知道<\/span><\/p>",
                "answer": "0",
                "askend": null,
                "answer_id": 2,
                "answer_url": "",
                "answertitle": null,
                "score": "0.00",
                "operation_score": 0
              },
            ],
            "video_list": [],
            "isok": 0,
            "isdone": 0,
            "concat_answer": "D",
            "user_concat_answer": ""
          }
        ]
      },
      // 互动答题
      // {
      //   "topic_id": 100,
      //   "id": 100,
      //   "type_id": 10,
      //   "typenm": "互动题",
      //   "shorttag": "",
      //   "showway": "",
      //   "topic_score": "8.00",
      //   "isauto": 0,
      //   "info": "",
      //   "km": "",
      //   "stem_url": "",
      //   "audiofile": "",
      //   "audiofile_suffix": "",
      //   "audiofile_title": "附件下载",
      //   "is_collect": 0,
      //   "status": 0,
      //   "is_play": 0,
      //   "issign": 0,
      //   "isok": 0,
      //   "isdone": 0,
      //   "getscore": 0,
      //   "comment": "",
      //   "ischeck": 0,
      //   "ps_info": "根据相关要求，完成下列题目。",
      //   "topic_sub": [
      //     {
      //       "shorttag": "",
      //       "direction": 0,
      //       "type_id": 10,
      //       "typenm": "互动题",
      //       "score": "8.00",
      //       "topic_id": 57,
      //       "sub_id": 1,
      //       "isauto": 0,
      //       "para44_id": 0,
      //       "upload_explain": "",
      //       "options": [],
      //       "showway": "",
      //       "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">阅读下列案例，然后回答问题。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">匠心筑梦，技能报国。不同领域的工匠们用勤劳的双手、默默的付出诠释着工匠精神。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">自主研发<\/span><span style=\"font-family:'宋体'; -aw-import:spaces\">&nbsp; <\/span><span style=\"font-family:'宋体'\">精密装配<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">先后参与溪洛渡水电站、白鹤滩水电站等重大水电站建设工程，从事水电装备制造工作30多年的崔兴国带领团队持续攻关、突破创新，为水电技术的发展做出了巨大贡献。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">崔兴国自主设计、研发的“通用可调节式”贯流式机组装配工装，大幅提高了所有产出的贯流式机组导水机构同心度、水平度、导叶开档尺寸及一次交检合格率，得到了广泛的应用和推广。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">转轮装配是水轮机组装配的重要一环。在白鹤滩水电站机组的转轮静平衡工作中，为了保证水轮机组转轮平稳运行，实现转轮静平衡试验目标，崔兴国采用了精准导向工装和扶正调整技术，使各项参数指标均优于精品标准。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">崔兴国还致力于研究制造业的智能化改造和数字化转型，提出要通过智能制造助力制造业转型升级，推动产品制造方式再创新，提高产品质量和制造效率。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">钻研工艺<\/span><span style=\"font-family:'宋体'; -aw-import:spaces\">&nbsp; <\/span><span style=\"font-family:'宋体'\">创新技法<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">一列动车组车体往往由许多大小不一、形状各异的铝合金板材组成，周晶辉的工作便是将这些铝合金板材和其他零部件精准组装成动车骨架，为下一步焊接做好准备。铝合金热传导速度快，焊接时稍有偏差，就可能导致车体变形。为了解决这一技术难题，他不断试验，成功探索出了可以使焊接时各个零部件受热均匀，减少车体变形情况的焊接工艺。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">周晶辉一直秉持着“不但要把活干完，更要把活干好”的工作理念。在制造时速200千米动车组时，他发现司机室小侧墙板材用传统方法切割非常烦琐。在没有技术参考的情况下，他用时一个多月，研究出了一套可在半小时内完成精准切割的切割方法。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">（资料来源：张文豪、王永战、刘以晴等，《弘扬工匠精神 磨炼精湛技艺》，《人民日报》，2024年5月1日）<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">结合上述案例，谈一谈你对工匠精神的认识。<\/span><\/p>",
      //       "subanalysis": "",
      //       "sortid": 1,
      //       "file_name": "",
      //       "user_answer": [],
      //       "brief_answer": {},
      //       "user_status": -1,
      //       "answer_img": {},
      //       "topic_answer": [
      //         {
      //           "topic_id": 57,
      //           "sub_id": 1,
      //           "sortid": 1,
      //           "ask": "",
      //           "answer": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">在长期的实践中，广大劳动者逐渐培育形成了“执着专注、精益求精、一丝不苟、追求卓越”的工匠精神。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">执着专注既是一种锲而不舍的工作态度，也是一种埋头苦干的工作习惯。崔兴国从事水电装备制造工作30多年，带领团队持续攻关、突破创新，正是执着专注的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">精益求精即要有一颗进取之心，以高标准要求自己，不断钻研工艺知识、提高技能水平。为了保证水轮机组转轮平稳运行，实现转轮静平衡试验目标，崔兴国采用了精准导向工装和扶正调整技术，使各项参数指标均优于精品标准，正是精益求精的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">一丝不苟即做事认真，不放过任何一个细节。周晶辉面对烦琐的工作，勤勤恳恳，不断试验，成功探索出了可以使焊接时各个零部件受热均匀，减少车体变形情况的焊接工艺，正是一丝不苟的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">追求卓越即不断进取、敢于开拓创新、勇于突破自我。在没有技术参考的情况下，周晶辉用时一个多月，研究出了一套可在半小时内完成精准切割的切割方法，正是追求卓越的体现。<\/span><\/p>",
      //           "askend": null,
      //           "answer_id": 1,
      //           "answer_url": "",
      //           "answertitle": null,
      //           "score": "8.00",
      //           "operation_score": 0
      //         }
      //       ],
      //       "topic_content": {
      //         // 交互 排一排
      //         key: 'section2.1.13', // *必填* 唯一标识
      //         type: 'action', // *必填* 类型：交互
      //         actionType: 2, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
      //         title: '交互 -- 排一排', // 标题
      //         titleStyle: {},
      //         content: {
      //           // 排一排
      //           key: 'action3',
      //           sortData: [
      //             {
      //               key: 'action3.1',
      //               actionKey: 'action3',
      //               title: '排序内容1',
      //               cover: require("@/assets/images/bookContent/图1-1  机器学习与人类思考的类比.png"),
      //               answerKey: 1
      //             },
      //             {
      //               key: 'action3.2',
      //               actionKey: 'action3',
      //               title: '排序内容2',
      //               cover: require("@/assets/images/bookContent/图1-2  数据相关术语.png"),
      //               answerKey: 2
      //             },
      //             {
      //               key: 'action3.4',
      //               actionKey: 'action3',
      //               title: '排序内容4',
      //               cover: require("@/assets/images/bookContent/图1-4  自动驾驶汽车.jpeg"),
      //               answerKey: 4
      //             },
      //             {
      //               key: 'action3.3',
      //               actionKey: 'action3',
      //               title: '排序内容3',
      //               cover: require("@/assets/images/bookContent/图1-3  自然语言处理.png"),
      //               answerKey: 3
      //             },
      //             {
      //               key: 'action3.5',
      //               actionKey: 'action3',
      //               title: '排序内容5',
      //               cover: require("@/assets/images/bookContent/图1-5  回归任务.png"),
      //               answerKey: 5
      //             },
      //           ],
      //           answerData: [3, 5, 1, 4, 2]
      //         },
      //       },
      //       "video_list": [],
      //       "isok": 0,
      //       "isdone": 0,
      //       "concat_answer": "",
      //       "user_concat_answer": ""
      //     }
      //   ]
      // },
      // 互动答题
      // {
      //   "topic_id": 101,
      //   "id": 101,
      //   "type_id": 10,
      //   "typenm": "互动题",
      //   "shorttag": "",
      //   "showway": "",
      //   "topic_score": "8.00",
      //   "isauto": 0,
      //   "info": "",
      //   "km": "",
      //   "stem_url": "",
      //   "audiofile": "",
      //   "audiofile_suffix": "",
      //   "audiofile_title": "附件下载",
      //   "is_collect": 0,
      //   "status": 0,
      //   "is_play": 0,
      //   "issign": 0,
      //   "isok": 0,
      //   "isdone": 0,
      //   "getscore": 0,
      //   "comment": "",
      //   "ischeck": 0,
      //   "ps_info": "根据相关要求，完成下列题目。",
      //   "topic_sub": [
      //     {
      //       "shorttag": "",
      //       "direction": 0,
      //       "type_id": 10,
      //       "typenm": "互动题",
      //       "score": "8.00",
      //       "topic_id": 58,
      //       "sub_id": 1,
      //       "isauto": 0,
      //       "para44_id": 0,
      //       "upload_explain": "",
      //       "options": [],
      //       "showway": "",
      //       "subinfo": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">阅读下列案例，然后回答问题。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">匠心筑梦，技能报国。不同领域的工匠们用勤劳的双手、默默的付出诠释着工匠精神。<\/span><\/p>",
      //       "subanalysis": "",
      //       "sortid": 1,
      //       "file_name": "",
      //       "user_answer": [],
      //       "brief_answer": {},
      //       "user_status": -1,
      //       "answer_img": {},
      //       "topic_answer": [
      //         {
      //           "topic_id": 57,
      //           "sub_id": 1,
      //           "sortid": 1,
      //           "ask": "",
      //           "answer": "<p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">在长期的实践中，广大劳动者逐渐培育形成了“执着专注、精益求精、一丝不苟、追求卓越”的工匠精神。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">执着专注既是一种锲而不舍的工作态度，也是一种埋头苦干的工作习惯。崔兴国从事水电装备制造工作30多年，带领团队持续攻关、突破创新，正是执着专注的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">精益求精即要有一颗进取之心，以高标准要求自己，不断钻研工艺知识、提高技能水平。为了保证水轮机组转轮平稳运行，实现转轮静平衡试验目标，崔兴国采用了精准导向工装和扶正调整技术，使各项参数指标均优于精品标准，正是精益求精的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">一丝不苟即做事认真，不放过任何一个细节。周晶辉面对烦琐的工作，勤勤恳恳，不断试验，成功探索出了可以使焊接时各个零部件受热均匀，减少车体变形情况的焊接工艺，正是一丝不苟的体现。<\/span><\/p> <p style=\"margin-top:0pt; margin-bottom:0pt; text-align:left; line-height:150%; font-size:10.5pt; font-family:Calibri;\"><span style=\"font-family:'宋体'\">追求卓越即不断进取、敢于开拓创新、勇于突破自我。在没有技术参考的情况下，周晶辉用时一个多月，研究出了一套可在半小时内完成精准切割的切割方法，正是追求卓越的体现。<\/span><\/p>",
      //           "askend": null,
      //           "answer_id": 1,
      //           "answer_url": "",
      //           "answertitle": null,
      //           "score": "8.00",
      //           "operation_score": 0
      //         }
      //       ],
      //       "topic_content": {
      //         // 交互 连连看
      //         key: 'section2.8', // *必填* 唯一标识
      //         type: 'action', // *必填* 类型：交互
      //         actionType: 1, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
      //         title: '连一连 请帮助吉祥物们找到属于自己的品牌。', // 标题
      //         titleStyle: {},
      //         content: {
      //           // 连连看
      //           key: 'action2',
      //           leftData: [
      //             {
      //               key: 'action2.1',
      //               actionKey: 'action2',
      //               title: '固定内容1',
      //               cover: require("@/assets/images/bookContent/图1-1  机器学习与人类思考的类比.png"),
      //               answerKey: 'key1'
      //             },
      //             {
      //               key: 'action2.2',
      //               actionKey: 'action2',
      //               title: '固定内容1',
      //               cover: require("@/assets/images/bookContent/图1-3  自然语言处理.png"),
      //               answerKey: 'key2'
      //             },
      //             {
      //               key: 'action2.3',
      //               actionKey: 'action2',
      //               title: '固定内容3',
      //               cover: require("@/assets/images/bookContent/图1-5  回归任务.png"),
      //               answerKey: 'key3'
      //             }
      //           ],
      //           rightData: [
      //             {
      //               key: 'action2.4',
      //               actionKey: 'action2',
      //               title: '拖拽内容1',
      //               cover: require("@/assets/images/bookContent/图1-4  自动驾驶汽车.jpeg"),
      //               answerKey: 'key2'
      //             },
      //             {
      //               key: 'action2.5',
      //               actionKey: 'action2',
      //               title: '拖拽内容2',
      //               cover: require("@/assets/images/bookContent/图1-2  数据相关术语.png"),
      //               answerKey: 'key1'
      //             },
      //             {
      //               key: 'action2.6',
      //               actionKey: 'action2',
      //               title: '拖拽内容3',
      //               cover: require("@/assets/images/bookContent/图1-6  分类任务.png"),
      //               answerKey: 'key3'
      //             }
      //           ],

      //         },
      //       },
      //       "video_list": [],
      //       "isok": 0,
      //       "isdone": 0,
      //       "concat_answer": "",
      //       "user_concat_answer": ""
      //     }
      //   ]
      // },
    ],
    completeType: 'statistics', // 答题完成后的操作 statistics：展示统计结果
  },
]
export default content